(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name cosmicRadiation.service:CosmicRadiationService
     *
     * @description
     *
     */
    angular
        .module('cosmicRadiation')
        .service('CosmicRadiationService', CosmicRadiationService);

    function CosmicRadiationService(rx, RemoteService, MessageService, CosmicRadiationFactory) {

        var self = this;
        self.data = {
            airports: [],
            cosmicRadiations: [],
            newCosmicRadiation: {}
        };

        self.createCosmicRadiation = function (data, successFn, errorFn) {
            deletePropertyFromObjects(data.records, 'isDisableDelete');

            var paramData = {
                origin: data.origin.airPortCode,
                destination: data.destination.airPortCode,
                timePeriods: data.records
            };

            RemoteService.addCosmicRadiationValue(paramData).then(
                function(response) {
                    successFn(response.data);
                    MessageService.success(MessageService.MESSAGES.COMMON.SUCCESS_SAVED);
                },
                function(error) {
                    console.log(error)
                    MessageService.error(error);
                    errorFn(error.msg[0]);
                }
            )
        };

        self.updateCosmicRadiation = function (data, records, successFn, errorFn) {
          deletePropertyFromObjects(records, 'isDisableDelete');

          var paramData = {
            origin: data.origin,
            destination: data.destination,
            timePeriods: records
          };

          RemoteService.editCosmicRadiationValues(paramData).then(
            function(response) {
              console.log('edit cosmic Radiation Value response', response);
              successFn(response.data);
              MessageService.success(MessageService.MESSAGES.COMMON.SUCCESS_SAVED);
            },
            function(error) {
                MessageService.error(error);
                errorFn(error.msg[0]);
            }
          )
        };

        self.getCosmicRadiationConfig = function(successFn, errorFn) {
          RemoteService.getCosmicRadiationConfig().then(
            function(response) {
              successFn(response.data);
          },
            function(error) {
                MessageService.error(error);
                errorFn(error.msg[0]);
            }
          )
        };

        self.getDefaultLocation = function () {
            self.data.airports = [];
            return self.data.airports[0];
        };

        self.setAirports = function (locations) {
            var t = self.getDefaultLocation();
            self.data.airports = self.data.airports.concat(locations);
        };

        self.getAirports = function () {
            return self.data.airports;
        };

        self.getAllCosmicRadiation = function () {
            return angular.copy(self.data.cosmicRadiations);
        };

        self.setAllCosmicRadiation = function(cosmicRadiations) {
            self.data.cosmicRadiations = cosmicRadiations;
        }

        self.getNewCosmicRadiation = function() {
          return angular.copy(self.data.newCosmicRadiation)
        }

        self.setNewCosmicRadiation = function(configData) {
          var minDate = configData.periodStartDate;
          var maxDate = moment(configData.periodStartDate,"DD/MM/YYYY")
            .add(configData.periodDuration, 'years').endOf('year').format("DD/MM/YYYY");

          var object = CosmicRadiationFactory.getNewCosmicRadiation();

          object.records[0] = {
            validFrom: minDate,
            validTo: maxDate,
            exposure: 0
          };

          self.data.newCosmicRadiation = object;
        }

        function deletePropertyFromObjects(array, propertyName) {
          array.forEach(function(obj) {
            if(obj.hasOwnProperty(propertyName)) {
              delete obj[propertyName] 
            }
          });
        }
    }
})();
